import { combineReducers } from "@reduxjs/toolkit";

import issuerSlice from "../features/issuer/issuerSlice";
import statusSlice from "../features/status/statusSlice";

const rootReducer = combineReducers({
    issuer: issuerSlice,
    status: statusSlice
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
